import { useNavigate } from 'react-router-dom'
import AramcoChhiForm from './AramcoChhiForm'
import AramcoAddBene from './AramcoAddBene'

function AramcoForm ({
  setChiReqRecord,
  setSystemType,
  chiReqRecord,
  systemType,
  eligibilityId,
  setEligibilityId,
  patientName,
  setPatientName
}) {
  const navigate = useNavigate()
  return (
    <div className='superGit_container'>
      <div className='benefeciary-create'>
        <AramcoChhiForm
          setChiReqRecord={setChiReqRecord}
          setSystemType={setSystemType}
          eligibilityId={eligibilityId}
          setEligibilityId={setEligibilityId}
          setPatientName={setPatientName}
        />
        <AramcoAddBene
          item={null}
          patientName={patientName}
          chiReqRecord={chiReqRecord}
          setChiReqRecord={setChiReqRecord}
          systemType={systemType}
          eligibilityId={eligibilityId}
          setEligibilityId={setEligibilityId}
        />
      </div>
    </div>
  )
}

export default AramcoForm
